<ul class="my-links">
  <li>
    <a
      routerLinkActive="active"
      (click)="onNavigate('roles')"
      routerLink="roles"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      roles
    </a>
  </li>
  <li>
    <a routerLinkActive="active" (click)="onNavigate('how-to-earn')" routerLink="how-to-earn">
      <div class="name">How To Earn</div>
    </a>
  </li>
  <li>
    <a routerLinkActive="active" (click)="onNavigate('rental-system-terms-and-conditions')" routerLink="rental-system-terms-and-conditions">
      <div class="name">RENTAL</div>
    </a>
  </li>
  <li>
    <a routerLinkActive="active" (click)="onNavigate('policies')" routerLink="policies">
      TERMS
    </a>
  </li>
  <li>
    <a routerLinkActive="active" (click)="onNavigate('faq')" routerLink="faq">
      kachiing Questions
    </a>
  </li>
  <!-- <li>
    <a
      routerLinkActive="active"
      (click)="onNavigate('refer')"
      routerLink="refer"
    >
      refer
    </a>
  </li>

  <li>
    <a
      routerLinkActive="active"
      (click)="onNavigate('write-articles')"
      routerLink="write-articles"
    >
      Write Articles
    </a>
  </li> -->
</ul>
<router-outlet></router-outlet>
